import styled from 'styled-components'

const Container = styled.div<{ centered?: boolean }>`
  display: flex;

  ${props => props.centered && `align-items: center;`};
`

export default Container
